import React from 'react'

export default () => (
    <main className="content">
        Politika
    </main>
)